import React from "react";
import { User } from "lucide-react";

import Layout from "src/components/layout/dashboard/Layout";
import Card from "src/components/common/card/Card";
import ProfileCardAdmin from "src/components/cards/ProfileCardAdmin";
import TenantDetailsCard from "src/components/cards/TenantDetailsCard";

import { useAppSelector } from "src/redux/hooks";

const SettingsProfilePage: React.FC = () => {
  const {
    user: { data: user },
  } = useAppSelector((state) => state.authAdmin);

  return (
    <Layout
      type="admin"
      meta={{
        title: "Profile | Invyntra Admin",
        description: "View and update your personal profile details.",
        keywords: "profile, settings, account, invyntra",
      }}
    >
      <div className="mx-auto max-w-3xl space-y-4">
        <div className="flex items-start gap-4">
          <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-primary-100 text-primary-600 dark:bg-primary-900/40 dark:text-primary-300">
            <User size={26} />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
              Profile
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Your personal details, visible only to you and other staff.
            </p>
          </div>
        </div>

        <Card>
          <ProfileCardAdmin userType="admin" />
        </Card>

        {user?.role !== "admin" && (
          <Card>
            <TenantDetailsCard />
          </Card>
        )}
      </div>
    </Layout>
  );
};

export default SettingsProfilePage;
